import { StoreDropdowns } from 'src/app/shared/models/app-models';
import { createReducer, on } from '@ngrx/store';
import { storeGenericDropDownOptions } from './dropDown.actions';
export const initialDdState: StoreDropdowns = {
  CostCentre: [],
  UOM: [],
  GLAcc: [],
  Currency: [],
  MaterialGroup: [],
  ProjectCode: [],
  ProjectBudget: [],
  FundCentre: [],
  MaterialSubGroup: [],
  OEM: [],
  ROAttachmentType: [],
  CEAttachmentType: [],
  AttachmentExtensions: [],
  UserList: [],
  DeliveryAddress: [],
  WOCReasons: [],
  PermissibleReason: [],
  DOTPReasons: [],
  ReasonForNotUsingRFQ: [],
  EstimatedUsages:[],
  RFQAbortReasons:[]
};

export const getInitialStoreDropdownsCopy = () => JSON.parse(JSON.stringify(initialDdState));

export const dropdownReducer = createReducer(
  initialDdState,
  on(storeGenericDropDownOptions, (state, dropdownOptions) => {
    return {
      ...dropdownOptions.dropdownOptions,
    };
  })
);
